/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_8_AInputs */

const en_tut_tr_8_a = /** @type {(inputs: Tut_Tr_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check three things in order: you have pressed **Nyalakan mikrofon** (listening alone never makes you audible), you are within six tiles of that person in the same area, and the area is not a private room, a locked room, or a focus zone — nearby audio is switched off in all of those by design.`)
};

const id_tut_tr_8_a = /** @type {(inputs: Tut_Tr_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periksa tiga hal berurutan: Anda sudah menekan **Nyalakan mikrofon** (mendengarkan saja tidak membuat Anda terdengar), Anda berada dalam enam petak dari rekan itu di area yang sama, dan area itu bukan ruang privat, ruang terkunci, atau zona fokus — di tempat-tempat itu audio sekitar memang dimatikan.`)
};

/**
* | output |
* | --- |
* | "Check three things in order: you have pressed **Nyalakan mikrofon** (listening alone never makes you audible), you are within six tiles of that person in the..." |
*
* @param {Tut_Tr_8_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_8_a = /** @type {((inputs?: Tut_Tr_8_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_8_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_8_a(inputs)
	return en_tut_tr_8_a(inputs)
});